import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const CourseRegisterWrap = styled.div`
  width: 300px;
  height: auto;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
`;

const Title = styled.h3`
  text-align: center;
  margin: 69px 0 48px 0;
  color: #333;
  font-size: 16px;
  line-height: 1.38;
`;

const Button = styled.button`
  width: 80%;
  padding: 10px 15px;
  background-color: #312a75;
  color: #fff;
  font-size: 12px;
  left: 50%;
  transform: translateX(-50%);
  position: relative;
  border-radius: 19.5px;
  margin-bottom: 37px;
  text-align: center;
`;

function CourseRegister({ initModal }) {
  const goCourse = () => {
    initModal();
  };

  console.log('CourseRegister');
  return (
    <CourseRegisterWrap>
      {/* <Close onClick={initModal} /> */}
      <Title>
        수강 신청하면
        <br />
        모든 수업을 학습할 수 있어요 :)
      </Title>
      <Link to="/">
        <Button onClick={() => goCourse()}>수강 신청하기</Button>
      </Link>
    </CourseRegisterWrap>
  );
}

export default CourseRegister;
